import { t } from "@lingui/macro";
import { add, format, parse } from "date-fns";

import { TeeSheetInfoCard } from "@whoosh/design-system/src/apps/PatronApp/screens/teesheet/components/TeeSheetInfoCard/TeeSheetInfoCard";
import { BlockIcon } from "@whoosh/design-system/src/components/icons_v2/general/icons/BlockIcon";
import { Box } from "@whoosh/design-system/src/components/primitive";
import { dateUtils } from "@whoosh/utilities";
import { CustomColor } from "@whoosh/utilities/src/colors";

export type TimeSlotListBlockProps = {
  name: string;
  startAt: string | null;
  color: CustomColor;
  durationMins: number;
};

export const TimeSlotListBlock = ({
  name,
  startAt,
  color,
  durationMins,
}: TimeSlotListBlockProps) => {
  const formatStartTime = startAt ? dateUtils.formatHHMM(startAt) : "";

  const endAt =
    startAt &&
    add(parse(startAt, "HH:mm:ss", new Date()), { minutes: durationMins ?? 0 });

  const formatEndTime = endAt ? format(endAt, "h:mm aaa") : "";

  const times = startAt ? `${formatStartTime} - ${formatEndTime}` : "";

  return (
    <Box alignItems="center" justifyContent="center" py={1} mt={3} width="100%">
      <TeeSheetInfoCard
        title={t`Blocked`}
        subTitle={times}
        bodyTitle={name}
        backgroundColor={getColor(color)}
        titleColor={getTextColor(color)}
        bodyColor={getTextColor(color)}
        icon={<BlockIcon />}
      />
    </Box>
  );
};

const getColor = (color: CustomColor) => {
  switch (color) {
    case "A":
      return "surface-user-selectable-colorA-subtle";
    case "B":
      return "surface-user-selectable-colorB-subtle";
    case "C":
      return "surface-user-selectable-colorC-subtle";
    case "D":
      return "surface-user-selectable-colorD-subtle";
    case "E":
      return "surface-user-selectable-colorE-subtle";
    case "F":
      return "surface-user-selectable-colorF-subtle";
    default:
      return "grayscale-200";
  }
};

const getTextColor = (color: CustomColor) => {
  switch (color) {
    case "A":
      return "text-user-selectable-colorA-inverse";
    case "B":
      return "text-user-selectable-colorB-inverse";
    case "C":
      return "text-user-selectable-colorC-inverse";
    case "D":
      return "text-user-selectable-colorD-inverse";
    case "E":
      return "text-user-selectable-colorE-inverse";
    case "F":
      return "text-user-selectable-colorF-inverse";

    default:
      return "text-primary";
  }
};
